export function normalizeDocumentStatus(raw) {
  if (raw == null) return '';
  const u = String(raw).trim().toUpperCase();
  if (u === 'AWAITING_SIGNATURE') return 'PENDING_SIGNATURE';
  if (u === 'SIGNED' || u === 'SIGN' || u === 'ASSINADO') return 'SIGNED';
  return u;
}

export const DOCUMENT_STATUS_META = {
  DRAFT: {
    label: 'Rascunho',
    className: 'bg-slate-100 text-slate-800 dark:bg-slate-800/60 dark:text-slate-200',
  },
  MANUAL: {
    label: 'Manual',
    className: 'bg-violet-100 text-violet-800 dark:bg-violet-950/50 dark:text-violet-200',
  },
  PDF_GENERATED: {
    label: 'PDF gerado',
    className:
      'bg-emerald-100 text-emerald-800 dark:bg-emerald-950/50 dark:text-emerald-200',
  },
  PDF_UPLOADED: {
    label: 'PDF enviado',
    className: 'bg-blue-100 text-blue-800 dark:bg-blue-950/50 dark:text-blue-200',
  },
  PENDING_SIGNATURE: {
    label: 'Aguardando assinatura',
    className: 'bg-amber-100 text-amber-900 dark:bg-amber-950/50 dark:text-amber-100',
  },
  SIGNED: {
    label: 'Assinado por todos',
    className: 'bg-green-100 text-green-800 dark:bg-green-950/50 dark:text-green-200',
  },
  ERROR: {
    label: 'Erro',
    className: 'bg-red-100 text-red-800 dark:bg-red-950/50 dark:text-red-200',
  },
};

export function getDocumentStatusMeta(statusRaw) {
  const key = normalizeDocumentStatus(statusRaw);
  if (DOCUMENT_STATUS_META[key]) {
    return { key, ...DOCUMENT_STATUS_META[key] };
  }
  return {
    key,
    label: key || '—',
    className: 'bg-muted text-muted-foreground',
  };
}
